'use strict';

const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');

module.exports = BaseView.extend({
    selectors: {
        findBookingItem: '.find_booking_item',
    },

    events: {
        'tap .find_booking_item': 'openFindBookingLink',
    },

    renderTemplate: function(data) {
        this.processFindBookingTemplateData(data);
        this.$el.html(this.templates.main({
            keys: this.keys,
            options: this.options,
        }));
    },

    emptyFindBookings: function() {
        this.$el.empty();
    },

    processFindBookingTemplateData: function(data) {
        this.keys = Odigeo._.extend(this.keys, {
            gtLink: Odigeo.Utils.replaceCmsKeyArgs(this.keys.gtLink, 'link-mytrips'),
        });
        this.options= Odigeo._.extend(this.options, {
            isHotelsLink: !Odigeo._.isEmpty(this.keys.isHotelsLink) && this.keys.isHotelsLink.toLowerCase() === 'true',
            isCarsLink: !Odigeo._.isEmpty(this.keys.isCarsLink) && this.keys.isCarsLink.toLowerCase() === 'true',
            isGtLink: !Odigeo._.isEmpty(this.keys.hasGtGlobal) && this.keys.hasGtGlobal.toLowerCase() === 'true' &&
            !Odigeo._.isEmpty(this.keys.hasGtLoginLocal) && this.keys.hasGtLoginLocal.toLowerCase() === 'true',
            categoryBookings: data,
        });
    },

    openFindBookingLink: function(e) {
        const link = $(e.currentTarget);
        const page = link.data('ref');
        const category = link.data('track-category');
        const action = link.data('track-action');
        const label = link.data('track-label');
        const place = Odigeo._.isEmpty(link.data('place')) ? '_self' : link.data('place');

        if (!Odigeo._.isEmpty(page)) {
            trackingUtils.trackEvent(action, label, category);
            Odigeo._.isEqual(place, '_blank') ? window.open(page) : window.open(page, place, false);
        }
    },

});
